function configureLatestChatbotAnalytics(opts) {
  void opts.replicantClientPromise.then((replicant) => {
    if (!replicant.extras.getLastReceivedChatbotMessagePayload || !opts.gcinstant.setLastReceivedChatbotMessagePayload) {
      return;
    }
    const lastReceivedChatbotMessagePayload = replicant.extras.getLastReceivedChatbotMessagePayload();
    if (lastReceivedChatbotMessagePayload) {
      opts.gcinstant.setLastReceivedChatbotMessagePayload(
        lastReceivedChatbotMessagePayload
      );
    }
  });
}
export {
  configureLatestChatbotAnalytics
};
